import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Button, Tooltip, Modal, message, Select } from "antd";
import { request, BaseComponent } from '@cm-sites-webber/components';

import './style.css';
import { PositionTypeContext } from '../../PositionAdd';
const { Option } = Select;

let timeout;
let currentValue;

/**
 * 危险处置人字段
 */
class Disposer extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: "",
            dangerDisposerData: [],
            searchUser: []
        };

        this.suffixDomRef = React.createRef();
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        if (this.suffixDomRef.current) {
            observer.observe(this.suffixDomRef.current);
        }else {
            this.setState({
                suffixWidth: 0,
            })
        }
        this.setState({
            value: this.props.fieldProps?.userInfo?.text
        })
    }

    getDangerDisposerData(searchWord, call) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        currentValue = searchWord;
        function fetchData() {
            const body = {
                "accountOrName": searchWord,
                "roleOption": [
                    "pms:positionSafe:dispose"
                ],
                "ifContainSonDept": 1,
                "start": 1,
                "size": 99999
            }
            this.request({
                url: "/cm-sites-sys/user/conditionQuery",
                body,
                method: "post",
                contentType: "json",
                callBack:(res)=>{
                    if (currentValue === searchWord) {
                        const result = res.data;
                        const data = result.flatMap(item => {
                            // 如果 item.deptList 不存在或不是数组，默认为空数组
                            const deptList = Array.isArray(item.deptList) ? item.deptList : [];
                            return deptList.map(deptItem => ({
                                userId: item.id,
                                name: item.name,
                                text: `${item.name}-${item.account}-${deptItem.name}`,
                                deptId: deptItem.id,
                                key: `${item.id}-${deptItem.id}`,
                            }));
                        });
                        call(data);
                    }
                },
                errorCallBack: (error)=>{

                },
            })
        }
        timeout = setTimeout(fetchData, 300);
    }

    handleAudioSearch = (value) => {
        if (value) {
            this.getDangerDisposerData(value, data => this.setState({searchUser: data}));
        } else {
            this.setState({searchUser: []});
        }
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(Disposer.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }

            return {...state,fieldProps:{...newProps}}
        }
        return state
    }


    renderSuffixButton() {
        // buttonDisabled= false
        const { buttonProps={},addDangerDisposer, delDangerDisposer, firstIndex, disabled } = this.props.fieldProps;
        return (
            <PositionTypeContext.Consumer>
                {(value) => {
                    return (
                        <>
                            {firstIndex > 0 ? <Button
                                disabled={disabled}
                                onClick={delDangerDisposer}
                                {...buttonProps}
                            >删除</Button> : null}
                            <Button
                                disabled={disabled}
                                onClick={addDangerDisposer}
                                style={{marginLeft: 5}}
                                {...buttonProps}
                            >添加处置人</Button>
                        </>
                    )
                }}
            </PositionTypeContext.Consumer>
        )
    }

    render() {
        const {prefixLayout, suffixLayout, style = {}, suffixButton, options,firstIndex} = this.props.fieldProps;
        const {fieldProps, suffixWidth, value, dangerDisposerData} = this.state;
        return (
            <>
                <div className="rmt-input disposer-add">
                    <div className="rmt-input-content-layout" style={{...style, width: `calc(100% - ${suffixWidth}px)`}}>
                        <Select getPopupContainer={triggerNode => triggerNode.parentElement} {...fieldProps} id={this.props.name} value={value || undefined} style={{width: "100%"}}
                                onChange={(e) => {
                                    this.setState({value: e})
                                    fieldProps.onChange(this.state.searchUser.find(item => item.key === e));
                                }}
                                notFoundContent={null}
                                filterOption={false}
                                showArrow={false}
                                defaultActiveFirstOption={false}
                                onSearch={this.handleAudioSearch}
                                allowClear
                                showSearch={true}
                        >
                            {this.state.searchUser.map((d) => {
                                return (
                                    <Option value={d.key} key={d.key}>
                                        {d.text}
                                    </Option>
                                )
                            })}
                        </Select>
                    </div>
                    <div className="rmt-input-suffix-layout" ref={this.suffixDomRef}>{this.renderSuffixButton()}</div>
                    <style>
                        {
                            `div[data-name = '${this.props.name}${firstIndex}'] .ant-form-item-children .disposer-add ~ .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth>0? suffixWidth : 35}px);
                        }`
                        }
                    </style>
                </div>
            </>
        )
    }

}
export default Disposer;

Disposer.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

Disposer.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: ()=>{}
}